import { FunctionComponent } from "react";
import { IBenhNhan } from "../models/DSBenhNhanKhamBenhModels";
import { handleConvertAddress } from "../../utils/AppFunction";
import { formatPatientRowData } from "../utils/Utils";
import { formatBirthdate } from "../../utils/FormatUtils";

interface InfoPatientRightProps {
  benhNhanInfo: IBenhNhan | undefined;
}

const InfoPatientRight: FunctionComponent<InfoPatientRightProps> = ({ benhNhanInfo }) => {
  let { patient, visit } = benhNhanInfo?.thongTinKhamBenh || benhNhanInfo || {};
  
  return (
    <>
      {benhNhanInfo ? (
        <div>
          <div className="text-break fw-500 p-1 text-end">
            <span className="text-uppercase fw-600 fs-7">
              {formatPatientRowData([
                patient?.personName,
                patient?.code,
                formatBirthdate(patient?.ageText, patient?.dobYear),
                patient?.gender
              ], '|')}
            </span>
            <div className="text-truncate fs-7">
              {visit?.visitObjectTypeName}&nbsp;|&nbsp;{handleConvertAddress(patient)}
            </div>
          </div>
        </div>
      ) : (
        <div className="info-patient spaces h-90"></div>
      )}
    </>
  );
};

export default InfoPatientRight;
